module.exports = __webpack_public_path__ + "static/media/menu-nav-chevron.39103b72.svg";